<template>
  <div id="FuelReadingView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Fuel Reading View</div>
          <div class="web-action-btn btn-groups text-right">
            <router-link class="btn btn-secondary pull-right ml-1" v-bind:to="{name: 'FuelReadingList'}" > <i class="fp-back"></i> Back</router-link>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content user-detail list-view">
            <div id="tabs" class="containerTab mt-4">
              <div class="tabs">
                <a v-on:click="activetab = 1" v-bind:class="[activetab === 1 ? 'active' : '']">Fuel Reading Details</a>
                <a v-on:click="activityLogs()" v-bind:class="[activetab === 2 ? 'active' : '']">Activity Log</a>
              </div>
              <div class="content">
                <div v-show="activetab === 1" class="tabcontent">
                  <div class="list-sections">
                    <div class="form-row section-divider" style="border-bottom:0px;">
                      <div class="col-md-6">
                        <div class="row form-group">
                            <label class="col">Reading Date :</label>
                            <span class="col">{{reading_date}}</span>
                        </div>
                        <!-- <div class="row form-group">
                            <label class="col">Item :</label>
                            <span class="col">{{item}}</span>
                        </div> -->
                        <div class="row form-group">
                            <label class="col">Location :</label>
                            <span class="col">{{location}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Tank No :</label>
                            <span class="col">{{tank_no}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Tank Start Reading :</label>
                            <span class="col">{{start_tank_reading}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Tank End Reading :</label>
                            <span class="col">{{end_tank_reading}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Total Tank Reading :</label>
                            <span class="col">{{tank_reading_total}}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row form-group">
                            <label class="col">Meter Start Reading :</label>
                            <span class="col">{{start_meter_reading}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Meter End Reading :</label>
                            <span class="col">{{end_meter_reading}}</span>
                        </div>
                        <div class="row form-group">
                            <label class="col">Total Meter Reading :</label>
                            <span class="col">{{meter_reading_total}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs">
                    <fuel-reading-activity-log-list :activityLogVal="activityLogsTabValue"></fuel-reading-activity-log-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="col-md-12">
          <div class="error-template">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  
  import {commonMixins} from '../mixins/commonMixins';
  import ActivityLogListView from '@/components/ActivityLogList.vue';
  Vue.component("fuel-reading-activity-log-list", ActivityLogListView);
  
  export default {
    name: "FuelReadingView",
    mixins:[commonMixins],
    data: () => ({
      permissions: [],
      cantAccessPage: "",
      loading:false,
      activetab: 1,
      activityLogsTabValue: "dontLoadList",
      activityLoaded:false,
      reading_date:'',
      item:'',
      location:'',
      tank_no:'',
      start_tank_reading:'',
      end_tank_reading:'',
      tank_reading_total:'',
      start_meter_reading:'',
      end_meter_reading:'',
      meter_reading_total:'',
    }),
    watch: {
      //check permission change
      permissions: function (permissions) {
          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'add_fuel_reading') {
                      self.cantAccessPage = true;
                  }
              }
          }
      }
    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFuelReadingDetails();
        var pathUrl = window.location.pathname;
        var segments = pathUrl.split("/");
        self.id=segments[3];
    },
    metaInfo() {
      return{
              title: "Fuel Reading View | " +process.env.COPYRIGHT_NAME
          }
    },
    methods: {
      loadFuelReadingDetails() {
        var path = window.location.pathname;
          var segments = path.split("/");
          var self = this;
          self.loading = true;
          $.ajax({
                    url: process.env.ROOT_API + "/fuel-reading/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data: {flag : 'view_by_id'},
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                          console.log(data.content[0].item);
                            self.reading_date = data.content[0].reading_date;
                            self.item =  data.content[0].item;
                            self.location = data.content[0].location;
                            self.tank_no = data.content[0].tank_no;
                            self.start_tank_reading = data.content[0].start_tank_reading;
                            self.end_tank_reading = data.content[0].end_tank_reading;
                            self.start_meter_reading = data.content[0].start_meter_reading;
                            self.end_meter_reading = data.content[0].end_meter_reading;
                            self.tank_reading_total = data.content[0].tank_reading_total;
                            self.meter_reading_total = data.content[0].meter_reading_total;
                        }
                    }
           });

      },
      activityLogs(){

        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        self.$root.$emit('activity_log_opted','fuel reading',segments[3]);
        self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
        self.activetab = 2;

      },
    },

  };

</script>




// WEBPACK FOOTER //
// src/components/FuelReadingView.vue